export const OP_ID = [
  { key: 'default', value: '默认', id: 0 }, // 占位用的，下面 1-9 才有实际意义
  { key: 'REGISTER', value: '注册工作室', id: 1 },
  { key: 'MODIFY', value: '修改工作室资料', id: 2 },
  { key: 'MODIFY_NAME', value: '修改工作室名字', id: 3 },
  { key: 'INVITE', value: '邀请加入工作室', id: 4 },
  { key: 'JOIN', value: '申请加入工作室', id: 5 },
  { key: 'KICK', value: '移除工作室成员', id: 6 },
  { key: 'QUIT', value: '申请退出工作室', id: 7 },
  { key: 'ADD_MAP', value: '创建地图', id: 8 },
  { key: 'VIP_AUDIT', value: '请求认证', id: 9 },
];

export const OP_STATE = [
  { key: 'default', value: '默认', id: 0 }, // 占位用的，下面 1-4 才有实际意义
  { key: 'REQUEST', value: '发起', id: 1 },
  { key: 'ACCEPT', value: '通过', id: 2 },
  { key: 'REJECT', value: '拒绝', id: 3 },
  { key: 'CANCEL', value: '撤销', id: 4 },
];

export const handleMembersHistory = arr => {
  if (!arr || !arr.length) return [];
  let temp = [];
  let OP_STATE_OBJ = {};
  let OP_ID_OBJ = {};
  OP_STATE.forEach(
    item => (OP_STATE_OBJ[item.key] = { value: item.value, id: item.id }),
  );
  OP_ID.forEach(
    item => (OP_ID_OBJ[item.key] = { value: item.value, id: item.id }),
  );
  for (let i = 0; i < arr.length; i++) {
    let { op, name, target_name, state } = arr[i];
    const WHITE_LIST = [
      OP_ID_OBJ['REGISTER'].id,
      OP_ID_OBJ['MODIFY'].id,
      OP_ID_OBJ['MODIFY_NAME'].id,
      OP_ID_OBJ['VIP_AUDIT'].id,
      OP_ID_OBJ['JOIN'].id,
      OP_ID_OBJ['QUIT'].id,
    ];
    if (
      op == OP_ID_OBJ['ADD_MAP'].id ||
      (~WHITE_LIST.indexOf(op) &&
        (state == OP_STATE_OBJ['ACCEPT'].id ||
          (op == OP_ID_OBJ['JOIN'].id && state == OP_STATE_OBJ['REQUEST'].id)))
    ) {
      switch (op) {
        case OP_ID_OBJ['REGISTER'].id:
          arr[i].text = `${name} 创建了工作室`;
          break;
        case OP_ID_OBJ['MODIFY'].id:
          arr[i].text = `${name} 更新了工作室资料`;
          break;
        case OP_ID_OBJ['MODIFY_NAME'].id:
          arr[i].text = `${name} 修改工作室名称为 ${arr[i].extra.name}`;
          break;
        case OP_ID_OBJ['VIP_AUDIT'].id:
          arr[i].text = `${name} 已完成工作室认证啦`;
          break;
        case OP_ID_OBJ['JOIN'].id:
          if (state == OP_STATE_OBJ['ACCEPT'].id) {
            arr[i].text = `${target_name} 加入了工作室`;
          } else {
            arr[i].text = `${name} 申请加入工作室`;
          }
          break;
        case OP_ID_OBJ['QUIT'].id:
          arr[i].text = `${name} 退出了工作室`;
          break;
        case OP_ID_OBJ['ADD_MAP'].id:
          arr[
            i
          ].text = `${name} 上传了地图 <a style="color:#2B6DDF;text-decoration:none;white-space:nowrap;" href="javascript:void(0);">${arr[i].extra.name}</a>`;
          break;
      }
      temp.push(arr[i]);
    } else {
      continue;
    }
  }
  return temp;
};

export const STUDIO_POSITION = [
  { key: 'default', value: '默认', id: 0 },
  { key: 'LEADER', value: '室长', id: 1 },
  { key: 'MEMBER', value: '成员', id: 2 },
  { key: 'MANAGER', value: '管理员', id: 3 },
];

export const ONE_DAY = 86400000;
export const ONE_HOUR = 3600000;

export const DESCRIPTION_DEFAULT = '暂无简介';
export const NOTICE_DEFAULT = '暂无公告';

export const UPLOAD_URL = process.env.VUE_APP_ENV.includes('prod')
  ? '//image_upload.mini1.cn/api/image/uploadWeb'
  : '//image-test.mini1.cn/api/image/uploadWeb';

export const UPLOAD_FILE_URL = process.env.VUE_APP_ENV.includes('prod')
  ? '//image_upload.mini1.cn/api/files/uploadWeb'
  : '//image-test.mini1.cn/api/files/uploadWeb';

export const checkLenStudioName = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入工作室名称'));
  }
  let len = value.length;
  let realLen = 0;
  let charCode = -1;
  for (let i = 0; i < len; i++) {
    charCode = parseInt(value.charCodeAt(i), 10);
    if (charCode >= 0 && charCode <= 128) {
      realLen += 1;
    } else {
      realLen += 3;
    }
  }
  if (realLen > (rule.max || 24)) {
    callback(new Error('已超出字数：中文最多8个或英文最多24个'));
  } else if (realLen < rule.min) {
    callback(
      new Error(
        `字数不得少于中文${Math.ceil(rule.min / 3)}个或英文${rule.min}个`,
      ),
    );
  } else {
    callback();
  }
};

const MAX_DEFAULT_FILE_SIZE = 1024 ** 2 * 10;
export const isValidFileSize = (size, failCb, maxSize) => {
  let _maxSize = maxSize || MAX_DEFAULT_FILE_SIZE;
  const pass = size <= _maxSize;
  if (!pass) failCb && failCb();
  return pass;
};

export const isValidPhone = str => {
  const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
  return reg.test(str);
};

export const isValidTel = str => {
  const reg = /0\d{2,3}-[1-9]\d{6,7}/;
  return reg.test(str);
};

export const isEmail = str => {
  const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  return reg.test(str);
};

export const isIntNum = val => {
  let regPos = /^\d+$/;
  return regPos.test(val);
};
